export const APPEARANCE_THEMES = ['light', 'dark', 'blue-white'] as const;

export type AppearanceTheme = (typeof APPEARANCE_THEMES)[number];

interface AppearanceThemeShortcutEvent {
  altKey: boolean;
  code: string;
  metaKey: boolean;
  repeat: boolean;
  shiftKey: boolean;
}

export function getNextAppearanceTheme(
  theme: string | undefined,
  resolvedTheme: string | undefined
): AppearanceTheme {
  const activeTheme = theme === 'system' ? resolvedTheme : theme;
  const activeIndex = APPEARANCE_THEMES.findIndex(
    candidate => candidate === activeTheme
  );

  return APPEARANCE_THEMES[(activeIndex + 1) % APPEARANCE_THEMES.length];
}

export function isAppearanceThemeRotationShortcut(
  event: AppearanceThemeShortcutEvent
): boolean {
  return (
    event.metaKey &&
    event.shiftKey &&
    !event.altKey &&
    !event.repeat &&
    event.code === 'Digit1'
  );
}
